import { useState, useEffect } from 'react';
import { listUsers, createUser, updateUser, deleteUser } from '@services/userService';
import Table from '@components/ui/Table';
import Button from '@components/ui/Button';
import Modal from '@components/ui/Modal';
import UserForm from './UserForm';
import { PlusCircle, Edit, Trash2 } from 'lucide-react';

export default function UserList() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const data = await listUsers();
      setUsers(data);
    } catch (error) {
      console.error('Erro ao buscar usuários:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleOpenModal = (user = null) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedUser(null);
    setIsModalOpen(false);
  };

  const handleSaveUser = async (userData) => {
    try {
      if (selectedUser) {
        await updateUser(selectedUser.id, userData);
      } else {
        await createUser(userData);
      }
      fetchUsers();
      handleCloseModal();
    } catch (error) {
      console.error('Erro ao salvar usuário:', error);
    }
  };

  const handleDeleteUser = async (userId) => {
    if (window.confirm('Tem certeza que deseja excluir este usuário?')) {
      try {
        await deleteUser(userId);
        fetchUsers();
      } catch (error) {
        console.error('Erro ao excluir usuário:', error);
      }
    }
  };

  const columns = [
    { label: 'Nome de Usuário', key: 'username' },
    { label: 'Email', key: 'email' },
    { label: 'Nome Completo', key: 'full_name' },
    {
      label: 'Perfil',
      key: 'profile',
      render: (value) => value?.name || '-'
    },
    {
      label: 'Status',
      key: 'is_active',
      render: (value) => (value ? 'Ativo' : 'Inativo')
    },
    {
      label: 'Ações',
      key: 'id',
      sortable: false,
      render: (value) => (
        <div className="flex space-x-2">
          <Button variant="icon" onClick={() => handleOpenModal(users.find(u => u.id === value))}>
            <Edit className="h-4 w-4" />
          </Button>
          <Button variant="icon" onClick={() => handleDeleteUser(value)}>
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">Usuários</h2>
        <Button variant="primary" onClick={() => handleOpenModal()}>
          <PlusCircle className="h-4 w-4 mr-2" />
          Novo Usuário
        </Button>
      </div>
      <Table columns={columns} data={users} isLoading={loading} />
      {isModalOpen && (
        <Modal isOpen={isModalOpen} title={selectedUser ? 'Editar Usuário' : 'Novo Usuário'} onClose={handleCloseModal}>
          <UserForm user={selectedUser} onSave={handleSaveUser} onCancel={handleCloseModal} />
        </Modal>
      )}
    </div>
  );
}